import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../../ui/portal";
import PortalAppBar from "../../ui/portalAppBar";
import PortalGridContent from "../../ui/portalGridContent";
import AdminReports from "../../widgets/adminReports";
import EmpireEmployees from "../../widgets/empireOS/empireEmployees";
import EmpireInformation from "../../widgets/empireOS/empireInformation";
import EmpireKPI from "../../widgets/empireOS/empireKPI";
import EmpireProcessMaps from "../../widgets/empireOS/empireProcessMaps";
import EmpireStoplight from "../../widgets/empireOS/empireStoplight";
import EmpireTodo from "../../widgets/empireOS/empireTodo";

const ProviderPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Empire OS" />
      <PortalGridContent>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <EmpireTodo />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <EmpireKPI />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <EmpireEmployees />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <EmpireInformation />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <EmpireProcessMaps />
        </Grid>
        <Grid item xs={12}>
          <EmpireStoplight />
        </Grid>
        <Grid item xs={6}>
          <AdminReports />
        </Grid>

        <Grid item xs={12}></Grid>
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(ProviderPortal);
